import { BoService } from '@alien-platform/bo-core';

let boInstance: BoService | null = null;

export function getBoInstance(): BoService {
  if (boInstance) {
    return boInstance;
  }

  boInstance = BoService.getInstance({
    baseUrl: `${process.env.BACKEND_BASE_URL}`,
    gamesBaseUrl: `${process.env.GAMES_BASE_URL}`,
    elasticBaseApiUrl: `${process.env.ELASTIC_BASE_API_URL}`,
    elasticApiKey: `${process.env.ELASTIC_API_KEY}`,
    eventHubConnection: `${process.env.EVENT_HUB_CONNECTION}`,
    env: `${process.env.ENV}`,
    gamesCmsUrl: `${process.env.GAMES_CMS_URL}`,
    notificationsUrl: `${process.env.NOTIFICATIONS_URL}`,
    deadletterLogsStorageConnection: `${process.env.DEADLETTER_LOGS_STORAGE_CONNECTION_STRING}`,
    deadletterLogsStorageContainerName: `${process.env.DEADLETTER_LOGS_STORAGE_CONTAINER_NAME}`,
    eventHubConnectionBase: `${process.env.EVENT_HUB_CONNECTION_BASE}`,
  });

  return boInstance;
}
